@if (VendorId && LocalizationInfo) {
  <form [formGroup]="InsuranceAgentFormGroup">
    <!-- Agency contact -->
    <div class="row g-3">
      <div class="col-md-6">
        <div class="form-group mb-0">
          <label class="form-label" requiredAsterisk for="ia-agencyName">
            Agency name
          </label>
          <input
            id="ia-agencyName"
            type="text"
            class="form-control"
            formControlName="agencyName"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group mb-0">
          <label class="form-label" requiredAsterisk for="ia-phone">
            Phone
          </label>
          <input
            id="ia-phone"
            type="text"
            class="form-control"
            [inputMask]="phoneMask"
            placeholder="(___) ___-____"
            formControlName="phone1"
          />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group mb-0">
          <label class="form-label" for="ia-ext">Ext.</label>
          <input
            id="ia-ext"
            type="text"
            class="form-control"
            [inputMask]="phoneExtensionMask"
            formControlName="phone1Ext"
          />
        </div>
      </div>
      <div class="col-12">
        <div class="form-group mb-0">
          <label class="form-label" requiredAsterisk for="ia-email">
            Email
          </label>
          <input
            id="ia-email"
            type="text"
            [pattern]="emailRegex.source"
            class="form-control"
            formControlName="email"
          />
        </div>
      </div>
    </div>

    <hr class="ia-divider" />

    <!-- Agent person -->
    <div class="row g-3">
      <div class="col-md-6">
        <div class="form-group mb-0">
          <label class="form-label" requiredAsterisk for="ia-firstName">
            First name
          </label>
          <input
            id="ia-firstName"
            type="text"
            class="form-control"
            formControlName="firstName"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group mb-0">
          <label class="form-label" requiredAsterisk for="ia-lastName">
            Last name
          </label>
          <input
            id="ia-lastName"
            type="text"
            class="form-control"
            formControlName="lastName"
          />
        </div>
      </div>
    </div>

    <hr class="ia-divider" />

    <!-- Policies handled -->
    <div class="form-group mb-0">
      <label class="form-label" requiredAsterisk>Policies handled</label>

      @if (currentInsuranceAgentPolicies.length > 0) {
        <div class="ia-policy-tags">
          @for (
            policy of currentInsuranceAgentPolicies;
            track policy;
            let index = $index
          ) {
            <span class="ia-policy-tag">
              {{ policy.label }}
              <button
                type="button"
                class="ia-policy-tag__remove"
                (click)="deselectPolicy(index, policy.value)"
                aria-label="Remove {{ policy.label }}"
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </span>
          }
        </div>
      } @else {
        <p class="ia-policy-empty">No policy types selected yet.</p>
      }

      <button
        type="button"
        class="btn btn-outline btn-sm mt-2"
        (click)="choosePolicyTypes()"
      >
        <i class="bi bi-plus-lg me-1"></i>
        Choose policy types
      </button>
    </div>

    @if (!hideSaveButton) {
      <div class="action-row justify-end mt-4 pt-3 border-top">
        <button type="button" class="btn btn-primary" (click)="saveAgent()">
          Save agent
        </button>
      </div>
    }
  </form>

  <!-- Canadian Workers' Comp coverage (US shows nothing here) -->
  @if (
    country === 'CA' &&
    CompanyVendorFormGroup.controls['CanadianWorkersCompensations']
  ) {
    @for (
      CanadianWorkersCompensationFormGroup of CompanyVendorFormGroup.controls[
        'CanadianWorkersCompensations'
      ].controls;
      track CanadianWorkersCompensationFormGroup
    ) {
      <form
        class="ia-cawc-section"
        [formGroup]="CanadianWorkersCompensationFormGroup"
      >
        <h4 class="ia-cawc-title">
          {{ CanadianWorkersCompensationFormGroup.controls['type'].value }}
          coverage
        </h4>
        <div class="row g-3">
          <div class="col-md-6">
            <div class="form-group mb-0">
              <label class="form-label" for="ia-cawc-number">
                {{
                  CanadianWorkersCompensationFormGroup.controls['type'].value
                }}
                account #
                @if (
                  !CanadianWorkersCompensationFormGroup.controls['CAWCExempt']
                    .value
                ) {
                  <span class="required-field-asterisk">*</span>
                }
              </label>
              <input
                id="ia-cawc-number"
                type="text"
                class="form-control"
                [inputMask]="numberMask"
                formControlName="CAWCNumber"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-0">
              <label class="form-label" for="ia-cawc-cert">
                Clearance certificate #
              </label>
              <input
                id="ia-cawc-cert"
                type="text"
                class="form-control"
                [inputMask]="alphanumericMask"
                formControlName="CAWCcertNumber"
              />
            </div>
          </div>
        </div>
      </form>
    }
  }
}
